import useReimbursementStore from '../../../screens/Forms/useReimbursementStore';
import { useState } from 'react';

export const QtyInput = ({ row, cell, field }) => {
    const [inputValue, setInputValue] = useState(cell);
    const handleChange = (e) => {
        let val = parseFloat(e.target.value);
        if (val === 0) {
            val = 1;
        }
        if (val > 999.99) {
            val = 999.99;
        }
        setInputValue(val);
    };

    const updateRow = useReimbursementStore((state) => state.updateRow);
    const handleTableInputChange = (e) => {
        updateRow(e.target.value, field, row.id);
    };

    return (
        <>
            <input
                type='number'
                min='1'
                value={inputValue}
                onChange={handleChange}
                onBlur={handleTableInputChange}
                className='form-control'
                max='999'
            />
        </>
    );
};
